<template>
  <div>
    <ListItemResult
      :value="value[militaryField]['name']"
      v-if="value[militaryField] && value[militaryField]['name']"
    >
      <div class="d-flex flex-wrap">
        <div class="pa-2 pl-0 text-subtitle-2">{{ militaryName }}:</div>
        <div class="pa-2">{{ value[militaryField]['name'] }}</div>
      </div>
    </ListItemResult>
    <ListItemResult
      :value="value[provinceField]['name']"
      v-if="value[provinceField] && value[provinceField]['name']"
    >
      <div class="d-flex flex-wrap">
        <div class="pa-2 pl-0 text-subtitle-2">{{ provinceName }}:</div>
        <div class="pa-2">{{ value[provinceField]['name'] }}</div>
      </div>
    </ListItemResult>
    <ListItemResult
      :value="value[districtField]['name']"
      v-if="value[districtField] && value[districtField]['name']"
    >
      <div class="d-flex flex-wrap">
        <div class="pa-2 pl-0 text-subtitle-2">{{ districtName }}:</div>
        <div class="pa-2">{{ value[districtField]['name'] }}</div>
      </div>
    </ListItemResult>
    <ListItemResult
      :value="value[communeField]['name']"
      v-if="value[communeField] && value[communeField]['name']"
    >
      <div class="d-flex flex-wrap">
        <div class="pa-2 pl-0 text-subtitle-2">{{ communeName }}:</div>
        <div class="pa-2">{{ value[communeField]['name'] }}</div>
      </div>
    </ListItemResult>
  </div>
</template>

<script>
import ListItemResult from './list-item-result.vue'
export default {
  components: { ListItemResult },
  props: {
    field: { type: Object, required: true },
    value: { type: Object, required: true },
  },
  computed: {
    militaryOption() {
      return Object.assign(this.field.meta.militaryOption || {}, {
        label: 'Quân khu',
        relation: 'military',
      })
    },
    provinceOption() {
      return Object.assign(this.field.meta.provinceOption || {}, {
        label: 'Tỉnh/Thành phố',
        relation: 'province',
      })
    },
    districtOption() {
      return Object.assign(this.field.meta.districtOption || {}, {
        label: 'Huyện',
        relation: 'district',
      })
    },
    communeOption() {
      return Object.assign(this.field.meta.communeOption || {}, {
        label: 'Xã',
        relation: 'commune',
      })
    },
    militaryName() {
      return this.militaryOption.label || 'Quân khu'
    },
    militaryField() {
      return this.militaryOption.relation || 'military'
    },
    provinceName() {
      return this.provinceOption.label || 'Tỉnh/Thành phố'
    },
    provinceField() {
      return this.provinceOption.relation || 'province'
    },
    districtName() {
      return this.districtOption.label || 'Huyện'
    },
    districtField() {
      return this.districtOption.relation || 'district'
    },
    communeName() {
      return this.communeOption.label || 'Xã'
    },
    communeField() {
      return this.communeOption.relation || 'commune'
    },
  },
}
</script>

<style></style>
